import { Stack, Button } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { I18nNamespace } from '~/common/types';
import { ChatMessageProps } from '~/common/types/ChatMessage';
import { ChatStep } from '~/components/ChatStep/ChatStep';
import { useUser } from '~/hooks/useUser/useUser';
import { RouteId } from '~/routes/RouteId';

type RequestSubmitProps = Pick<ChatMessageProps, 'role' | 'createdBy'> & {
  profile: ReturnType<typeof useUser>['profile'];
  disabled?: boolean;
  release?: () => void;
};

export const RequestSubmit = ({ role, createdBy, profile, disabled, release }: RequestSubmitProps) => {
  const { t: tIntake } = useTranslation(I18nNamespace.intake);
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeRequestSubmitStep' });
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    release?.();
  }, [release]);

  return (
    <ChatStep
      title={tIntake('IntakeChatStep.assistant')}
      role={role}
      createdBy={createdBy}
      message={t('message.proceed', profile)}
      footer={
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            disabled={disabled}
            onClick={() => {
              navigate(RouteId.intake);
            }}
          >
            {t('button.saveDraft')}
          </Button>
          <Button color="primary" variant="contained" disabled={disabled} onClick={onClick}>
            {t('button.submit')}
          </Button>
        </Stack>
      }
    />
  );
};
